import { create } from 'zustand';

export type SpaceConfiguration = {
  api: string;
  domain: string;
  title: string;
};

export type SpaceDomainStoreType = {
  configuration: SpaceConfiguration | null;
  setConfiguration: (config: SpaceConfiguration | null) => void;
};

export const SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY = 'debug_space_config';

export const useSpaceDomainStore = create<SpaceDomainStoreType>(set => ({
  configuration: window.localStorage.getItem(SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY) ? JSON.parse(
    window.localStorage.getItem(SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY)!
  ) : null,
  setConfiguration: configuration => {
    if (!configuration) {
      window.localStorage.removeItem(SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY);
    } else {
      window.localStorage.setItem(
        SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY,
        JSON.stringify(configuration)
      );
    }
    set(state => ({
      ...state,
      configuration,
    }));
  },
}));
